import axios from "axios";

export const LOCAL_PROXY_ORIGIN = "http://localhost:8080";

const useLocalProxy =
  import.meta.env.DEV && import.meta.env.VITE_USE_LOCAL_PROXY === "true";

export const API_BASE_URL = useLocalProxy
  ? `${LOCAL_PROXY_ORIGIN}/v2`
  : (import.meta.env.VITE_API_URL as string);
export const DOWNLOAD_BASE_URL = useLocalProxy
  ? `${LOCAL_PROXY_ORIGIN}/output/`
  : (import.meta.env.VITE_DOWNLOAD_MOVEMENTS_URL as string);

export const configureAxiosBaseUrl = () => {
  axios.defaults.baseURL = API_BASE_URL;
};

export const normalizeDownloadUrl = (url: string): string => {
  if (!useLocalProxy) {
    return url;
  }

  if (url.startsWith(`${LOCAL_PROXY_ORIGIN}/output/`)) {
    return url;
  }

  if (url.startsWith("/output/")) {
    return `${LOCAL_PROXY_ORIGIN}${url}`;
  }

  try {
    const parsedUrl = new URL(url);
    const isRadarOutputUrl =
      parsedUrl.hostname.includes("somosradar.com") &&
      parsedUrl.pathname.startsWith("/output/");

    if (isRadarOutputUrl) {
      return `${LOCAL_PROXY_ORIGIN}${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
    }
  } catch {
    return url;
  }

  return url;
};
